import axios from "axios";
import { authHeader } from "@/helpers/API/Auth/auth.header.js";
import { message } from "ant-design-vue";
const API_URL = process.env.VUE_APP_ROOT_API;

class AccountService {
  // CONTACT RELATED APIs

  // Get account details
  async getAccountData() {
    return await axios
      .get(API_URL + "crm/account", { headers: authHeader() })
      .then((response) => {
        if (response.status == false) {
          return message.info(response.message);
        }
        let resData = JSON.stringify(response.data);
        localStorage.setItem("account", resData);
        return response.data;
      });
  }

  // Update account details
  async updateAccount(data) {
    return await axios
      .patch(API_URL + "crm/account", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new AccountService();
